import { useEffect, useState } from 'react';

/** How long a file read goes unannounced: a small file is read before the user could notice. */
export const DELAI_LECTURE_MS = 300;

/**
 * `true` once `actif` has been true for `delai` milliseconds without a break, `false` as
 * soon as it is false again. It keeps a short state from flashing on the screen.
 */
export function useApresDelai(actif: boolean, delai: number = DELAI_LECTURE_MS): boolean {
  const [ecoule, setEcoule] = useState(false);

  useEffect(() => {
    if (!actif) {
      setEcoule(false);
      return;
    }
    const minuteur = setTimeout(() => setEcoule(true), delai);
    return () => clearTimeout(minuteur);
  }, [actif, delai]);

  return actif && ecoule;
}
